/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AdmissionAccidentMasterApi } from '../api/admissionAccidentMaster.api';
import { switchMap, map } from 'rxjs/operators';
import {  AdmissionAccidentMasterData,AdmissionAccidentMaster} from '../../../interfaces/Ip/admissionAccident';

@Injectable()
export class AdmissionAccidentMasterService extends AdmissionAccidentMasterData {

  constructor(private api: AdmissionAccidentMasterApi) {
    super();
  }


  list(url: string): Observable<AdmissionAccidentMaster[]> {
    return this.api.list(url);
  }

  create(url: string, data:AdmissionAccidentMaster): Observable<AdmissionAccidentMaster> {
    return this.api.add(url,data);
  }

  update(url: string, data:AdmissionAccidentMaster): Observable<AdmissionAccidentMaster> {
    return this.api.update(url,data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }


}
